const doCase = {
  data() {
    return {
      AloneControl: ["MATERIALANALYSISPROBLEM", "DIALOGUE"]
    };
  },
  methods: {
    SpeedOfProgress() {
      // // 添加进度
      // const data2 = {
      //   schedule: Schedule,
      //   experimentId: this.doCase.experimentId,
      //   pyId: this.doCase.caseId,
      //   userId: this.$role.code,
      //   classId: sessionStorage.getItem("classId")
      // };
      // this.$http.createOrUpdateExperimentMember(data2).then(res => {
      //   console.log(res);
      //   if (res.data.success) {
      //     sessionStorage.setItem("schedule", res.data.data.schedule);
      //   }
      // });
    },
    doCaseQueryControl() {
      /** 根据场景ID查询控件 */
      const data = {
        tsId: this.cont.id
      };
      this.$http.listControlByTsid(data).then(res => {
        console.dir("场景里的空间", res);
        this.sceneControlList = res.data.data;
        if (this.sceneControlList.length !== 0) {
          this.AssessmentIndex = 0;
        }
      });
    }
  }
};
export default doCase;
